/**
 * 老师查询添加教参
 * 谢冉
 * 2020.8.25
 */
import '@instructure/canvas-theme';
import React, { useState, useEffect } from 'react';
import { Tabs } from '@instructure/ui-tabs'
import { Alert } from '@instructure/ui-alerts';
import Marquee from 'react-fast-marquee';
import { useSessionStorageState } from 'ahooks';
import { search2query } from '../utils/store';
import GuideBooks from '../components/GuideBooks';
import GuidePapers from '../components/GuidePapers';
import { instance } from '../axios';

const GuideBooksWrap = (props) => {
  const paramsObj = search2query(props.location.search);
  const [kcdm, setKcdm] = useState('');
  const [selectedIndex, setSelectedIndex] = useSessionStorageState(
    'canvas_home_tab',
    {
      defaultValue: {
        listenStorageChange: true, // 数据联动开关
        defaultValue: 0, // 默认值数据
      },
    },
  );
  const [showTip, setShowTip] = useSessionStorageState(
    'canvas_home_tip',
    {
      defaultValue: {
        listenStorageChange: true, // 数据联动开关
        defaultValue: true, // 默认值数据
      },
    },
  );

  useEffect(() => {
    instance({
        method: 'post',
        url: `queryKcinfoByBsidAndGh`,
        data: {
          bsid: paramsObj.courseId,
          gh: paramsObj.ghId,
        },
      })
    .then(res => {
      if (res?.data?.data) {
        setKcdm(res.data?.data?.kcdm || '');
      }
    })
  }, [paramsObj.courseId, paramsObj.ghId])
  

  const handleTabChange = (event, { index }) => {
    setSelectedIndex(index)
  }

  return (
    <div style={{ height: '100vh' }}>
      {paramsObj.isTeacher && paramsObj.isTeacher === 'true' && showTip && <Alert
        variant="info"
        renderCloseButtonLabel="Close"
        margin="small"
        transition="none"
        onDismiss={() => setShowTip(false)}
      >
        <Marquee pauseOnHover gradient={false}>
          教参系统新增“保障顺序”功能，可设置保障优先级。图书馆按照保障顺序处理未电子化教参。
        </Marquee>
      </Alert>}
      <Tabs
        margin="0 auto"
        padding="medium"
        onRequestTabChange={handleTabChange}
      >
        <Tabs.Panel
          id="tabA"
          renderTitle='书籍教参'
          // textAlign="center"
          // padding="large"
          isSelected={selectedIndex === 0}
        >
          <GuideBooks {...props} kcdm={kcdm} />
        </Tabs.Panel>

        <Tabs.Panel
          id="tabC"
          renderTitle="论文教参"
          isSelected={selectedIndex === 1}
        >
          <GuidePapers {...props}  kcdm={kcdm} />
        </Tabs.Panel>
      </Tabs>
    </div>
  )
}
export default GuideBooksWrap;
